import { I18N_FORMAT_MAP } from '@rover/kibble/styles';
import type { LocalizedFormatFunction, StrictStringMap } from '@rover/react-lib/types';
import { DEFAULT_LANG } from '@rover/shared/js/constants/i18n/language';

import generateExternalFormatMap from './generateExternalFormatMap';

const generateFormatMap = (
  getLocalizedFormat: LocalizedFormatFunction,
  language?: string | undefined
): StrictStringMap =>
  Object.keys(I18N_FORMAT_MAP[DEFAULT_LANG]).reduce((acc, key) => {
    acc[key] = getLocalizedFormat(key, language);
    return acc;
  }, generateExternalFormatMap(getLocalizedFormat, language));

export default generateFormatMap;



// WEBPACK FOOTER //
// ../shared/js/constants/i18n/datetime/generateFormatMap.ts